import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinKyuyoMasterV2GetRes,
  TZyomuinKyuyoMasterV2ListGetReq,
  TZyomuinKyuyoMasterV2ListGetRes,
  TZyomuinKyuyoMasterV2RegisterPostReq,
  TZyomuinKyuyoMasterV2RegisterPutReq,
  TZyomuinKyuyoMasterV2PutListKihonkyuReq,
  TZyomuinKyuyoMasterV2ResetHyokaKubunReq,
} from "./TZyomuinKyuyoMaster"

/**
 * 乗務員給与マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinKyuyoMasterV2Service
 * @extends {ConnectApi}
 */
export default class ZyomuinKyuyoV2Service extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinKyuyoMasterV2ListGetReq} params
   * @memberof ZyomuinKyuyoMasterV2Service
   */
  getList = async (
    params: TZyomuinKyuyoMasterV2ListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoMasterV2ListGetRes>> =
        await this.getInner(
          `/driverpayroll/zyomuinkyuyomaster/v2`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoMasterV2GetRes>> =
        await this.getInner(
          `/driverpayroll/zyomuinkyuyomaster/v2/${id}`,
          signal
        )
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZyomuinKyuyoMasterV2RegisterPutReq} data
   * @param {(param: TApiResponse<TZyomuinKyuyoMasterV2GetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinKyuyoMasterV2GetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (
    id: number,
    data: TZyomuinKyuyoMasterV2RegisterPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyomaster/v2/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 新規登録
   *
   * @param {TZyomuinKyuyoMasterV2RegisterPostReq} data
   * @memberof KyotenService
   */
  post = async (
    id: number,
    data: TZyomuinKyuyoMasterV2RegisterPostReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driverpayroll/zyomuinkyuyomaster/v2/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 基本給一括更新
   *
   * @param {TZyomuinKyuyoMasterV2RegisterPutReq} data
   * @param {(param: TApiResponse<TZyomuinKyuyoMasterV2GetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinKyuyoMasterV2GetRes>>) => any} reject
   * @memberof KyotenService
   */
  putListKihonkyu = async (
    data: TZyomuinKyuyoMasterV2PutListKihonkyuReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyomaster/v2/actions/putListKihonkyu`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 計算用評価区分一括リセット
   *
   * @param {TZyomuinKyuyoMasterV2ResetHyokaKubunReq} data
   * @memberof ZyomuinKyuyoMasterV2Service
   */
  resetHyokaKubun = async (
    data: TZyomuinKyuyoMasterV2ResetHyokaKubunReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyomaster/v2/actions/resetHyokaKubun`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
